import { FormInputElement, FormInputTypes } from '@typedream/core';
import { setNodes } from '@udecode/plate-core';
import { memo } from 'react';
import shallow from 'zustand/shallow';
import { Dropdown, DropdownItem } from '../../../components/Dropdown';
import { useTPlateEditorRef } from '../../../plate';
import { getSelectedElementEntry } from '../../../plugins/elementSelection';
import { useDreamEditorStore } from '../../../plugins/store';
import styles from '../SideToolbar.module.css';

// capitalize first letter of string
function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function InputType() {
  const editor = useTPlateEditorRef();

  const [label, filteredOptions] = useDreamEditorStore(() => {
    const entry = getSelectedElementEntry<FormInputElement>(editor);

    if (!entry) return ['', []];

    const { inputType } = entry[0];
    const opts = FormInputTypes;

    return [inputType || '', opts];
  }, shallow);

  return (
    <div className="mt-5 mb-5">
      <span className={styles.label}>Block Type</span>
      <Dropdown
        triggerLabel={capitalizeFirstLetter(label) || 'Select a Block'}
        disabled={filteredOptions.length === 0}
      >
        {Object.values(filteredOptions).map((opt) => (
          <DropdownItem key={opt}>
            <div
              role="none"
              className="is-capitalized"
              onMouseDown={() => {
                const path = getSelectedElementEntry(editor)?.[1];
                if (path) {
                  setNodes(editor, {
                    inputType: opt,
                  }, {
                    at: path,
                  });
                }
              }}
            >
              {capitalizeFirstLetter(opt || '')}
            </div>
          </DropdownItem>
        ))}
      </Dropdown>
    </div>
  );
}

export default memo(InputType);
